import React from "react";
import styles from "./CookiesPolicy.module.scss";
import logoBlackSquare from "../assets/footer/cork-square-logo.png";
import { Link } from "react-router-dom";

export default function CookiesPolicy() {
  const currentYear = new Date().getFullYear();

  return (
    <div className={styles.CookiesPolicy}>
      <div className={styles.grid}>
        <div className={styles.logoContainer}>
          <Link to="/">
            <img src={logoBlackSquare} />
          </Link>
        </div>
        <div className={styles.mainColumn}>
          <h1>Cookies Policy</h1>

          <p>
            This Cookies Policy explains how Cork Matters ("we", "us", or "our")
            uses cookies and similar technologies on our website. By using our
            website, you consent to the use of cookies in accordance with this
            policy. This policy should be read in conjunction with our Privacy
            Policy, which explains how we handle your personal data.
          </p>

          <h2>What Are Cookies?</h2>
          <p>
            Cookies are small text files that are placed on your device
            (computer, smartphone, or tablet) when you visit a website. They are
            widely used to make websites work more efficiently, as well as to
            provide information to the website owners. Cookies can be
            "persistent" (stored on your device between sessions) or "session"
            (deleted when you close your browser).
          </p>
          <p>
            We also use similar technologies such as pixels, tags, and web
            beacons, which serve similar purposes and are covered by this
            policy.
          </p>

          <h2>Types of Cookies We Use</h2>
          <p>
            We categorize cookies based on their purpose. We use the following
            types:
          </p>

          <h2>Essential Cookies</h2>
          <p>
            These cookies are necessary for the website to function properly.
            They enable basic features like page navigation and access to secure
            areas. The website cannot function properly without these cookies,
            and they are usually set in response to your actions (e.g., setting
            privacy preferences or filling out forms). You can set your browser
            to block or alert you about these cookies, but some parts of the
            site may not work.
          </p>
          <p>
            Examples: Session cookies for maintaining your login status or cart
            contents.
          </p>

          <h2>Analytics Cookies</h2>
          <p>
            These cookies help us understand how visitors interact with our
            website by collecting and reporting information anonymously. We use
            Firebase Analytics (provided by Google) to track events such as
            button clicks, add-to-cart actions, and purchases. This data helps
            us improve our website and services.
          </p>
          <p>
            Firebase Analytics may collect information like your device type,
            browser, IP address (anonymized), and usage patterns. For more
            details, see Google's Privacy Policy at
            https://policies.google.com/privacy.
          </p>

          <h2>Advertising Cookies</h2>
          <p>
            These cookies are used to deliver advertisements that are more
            relevant to you and your interests. We use Google Ads to display
            targeted ads on our site and across the web. Google Ads cookies
            track your visits to our site and other websites to build a profile
            of your interests.
          </p>
          <p>
            This may involve sharing data with Google for ad personalization.
            You can opt out of personalized ads via Google's Ads Settings at
            https://adssettings.google.com. For more information, refer to
            Google's Privacy Policy.
          </p>

          <h2>Third-Party Cookies</h2>
          <p>
            Some cookies are placed by third-party services that appear on our
            pages, such as Google Ads and Firebase. We have no direct control
            over these cookies, but we ensure they comply with applicable laws.
            You can manage these through the third parties' privacy settings or
            your browser.
          </p>

          <h2>How We Obtain Your Consent</h2>
          <p>
            When you first visit our website, we display a cookie consent banner
            that allows you to accept or reject non-essential cookies (analytics
            and advertising). Essential cookies do not require consent as they
            are necessary for the site's operation. You can withdraw your
            consent at any time by adjusting your browser settings or using our
            cookie management tool (if available).
          </p>
          <p>
            Under EU law (including GDPR and the ePrivacy Directive as
            implemented in Portugal), we obtain explicit consent for
            non-essential cookies before they are set.
          </p>

          <h2>How to Manage Cookies</h2>
          <p>You can control cookies through your browser settings:</p>
          <ul>
            <li>
              Chrome: Go to Settings > Privacy and security > Cookies and other
              site data.
            </li>
            <li>
              Firefox: Options > Privacy & Security > Cookies and Site Data.
            </li>
            <li>Safari: Preferences > Privacy > Manage Website Data.</li>
            <li>
              Edge: Settings > Cookies and site permissions > Manage and delete
              cookies.
            </li>
          </ul>
          <p>
            Blocking cookies may affect your experience on our site. For more
            information on cookies, visit www.allaboutcookies.org.
          </p>

          <h2>Changes to This Cookies Policy</h2>
          <p>
            We may update this policy from time to time to reflect changes in
            our practices or legal requirements. We will notify you of
            significant changes by posting the updated policy on our website
            with the effective date. Your continued use of the site after
            changes constitutes acceptance.
          </p>

          <h2>Contact Information</h2>
          <p>
            If you have questions about this Cookies Policy, please contact us
            at{" "}
            <a href="mailto:corkmatters.online@gmail.com">
              corkmatters.online@gmail.com
            </a>
            .
          </p>
          <p>Last updated: September 29, 2025</p>
        </div>
      </div>
    </div>
  );
}
